

import TiwiMixin from '../mixins/TiwiMixin'

export default {
  mixins: [TiwiMixin],

  props: {
    postType: {
      required: true,
      type: String,
    },
    className: {
      required: false,
      type: String,
      default: '',
    },
    label: {
      required: false,
      type: String,
      default: null,
    },
   
  },
  computed: {
    post_type() {
      return this.getPostTypeMeta(this.postType);
    },
    
  }

}
